import { API_URLS } from '@bg-shared/constants';
import { GameId } from '@bg-shared/enums';
import { httpClientRepository } from '@bg-shared/infrastructure';
import { IStagedBetsResponseData } from '@bg-shared/business/CasinoBetting/interfaces';

export class StagedBetsApi {
    public getStagedBets(gamesIds: GameId[]) {
        return httpClientRepository.get<{
            data: IStagedBetsResponseData;
        }>(API_URLS.STAGED_BETS, {
            params: {
                gamesIds,
            },
            transformRequest: false,
        });
    }
}
